import { useEffect } from 'react';
import { useTypedText } from '../hooks/useTypedText';
import { loadCalendlyScripts, openCalendlyPopup } from '../utils/calendly';
import logo from '../assets/quanturama-logo.png';

const Hero = () => {
  const phrases = [
    'AI Trading Systems',
    'Web3 Infrastructure',
    'Automation Pipelines',
    'Agent Architectures'
  ];

  const { typedText, fadeClass } = useTypedText(phrases);
  const particles = [
    { top: '12%', left: '18%', size: '3px', duration: '18s', delay: '0s' },
    { top: '22%', left: '68%', size: '2px', duration: '16s', delay: '1s' },
    { top: '38%', left: '32%', size: '2px', duration: '20s', delay: '2s' },
    { top: '48%', left: '78%', size: '3px', duration: '15s', delay: '1.5s' },
    { top: '62%', left: '24%', size: '2px', duration: '17s', delay: '0.5s' },
    { top: '72%', left: '56%', size: '3px', duration: '19s', delay: '2.5s' },
    { top: '18%', left: '52%', size: '2px', duration: '14s', delay: '3s' },
    { top: '30%', left: '84%', size: '2px', duration: '21s', delay: '1.2s' },
    { top: '54%', left: '12%', size: '3px', duration: '16s', delay: '2.2s' },
    { top: '66%', left: '70%', size: '2px', duration: '22s', delay: '0.8s' },
    { top: '82%', left: '38%', size: '2px', duration: '18s', delay: '1.8s' },
    { top: '8%', left: '40%', size: '2px', duration: '15s', delay: '2.8s' },
    { top: '44%', left: '50%', size: '3px', duration: '20s', delay: '0.3s' },
    { top: '76%', left: '88%', size: '2px', duration: '17s', delay: '1.1s' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    loadCalendlyScripts();
  }, []);

  return (
    <section className="hero-section" id="home">
      <div className="hero-background">
        <div className="gradient-mesh"></div>
        <div className="particle-field">
          {particles.map((particle, idx) => (
            <span
              key={idx}
              className="particle"
              style={{
                top: particle.top,
                left: particle.left,
                width: particle.size,
                height: particle.size,
                animationDelay: particle.delay,
                animationDuration: particle.duration
              }}
            />
          ))}
        </div>
      </div>

      <div className="hero-container">
        <div className="hero-content">


          <p className="hero-eyebrow">Automation · Web3 · AI Systems</p>

          <h1 className="hero-title">
            Systems that <span className="gradient-text">run without you.</span>
          </h1>

          <h2 className="hero-subtitle typing-container">
            We build{' '}
            <span className={`typed-text ${fadeClass}`}>
              <span className="typed-text-content">{typedText}</span>
              <span className="typing-cursor">|</span>
            </span>
          </h2>

          <p className="hero-description">
            Trading infrastructure, Web3 architecture, and automation pipelines — architected, built, and handed off to operators who need them live.
          </p>

          <div className="hero-cta">
            <button className="btn btn-primary" onClick={() => scrollToSection('services')}>
              <span>See What We Build</span>
              <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button
              className="btn btn-secondary"
              type="button"
              onClick={openCalendlyPopup}
            >
              <span>Book a Free Strategy Call</span>
            </button>
          </div>
        </div>

        <div className="hero-right-panel">
          <div className="module-card-block">
            <div className="window-header">
              <div className="window-controls">
                <span className="window-control close" aria-hidden="true"></span>
                <span className="window-control minimize" aria-hidden="true"></span>
                <span className="window-control maximize" aria-hidden="true"></span>
              </div>
              <span className="window-title">quanturama.exe</span>
              <button className="window-exit" type="button" aria-label="Close window">×</button>
            </div>

            <div className="window-body">
              <div className="window-screen">
                <div className="window-overlay-text">
                  <h4>{'</>'} Ready to build?</h4>
                  <p>Strategy call → Proposal → Launch.</p>
                </div>
                <div className="window-logo">
                  <img src={logo} alt="Quanturama Logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
